<script setup>
import { onMounted } from "vue";

import { get } from "@/apis/index.js";

onMounted(async () => {
  // const { data } = await get("/api/classpal/app/v1/h5/we-chat/getJsapiTicket", {
  //   // url: `http://dev.banxueketang.com${window.location.pathname}${window.location.search}`,
  //   url: location.href.split("#")[0],
  // });
  // wx.config({
  //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
  //   appId: data.appId, // 必填，服务号的唯一标识
  //   timestamp: data.timestamp, // 必填，生成签名的时间戳
  //   nonceStr: data.nonceStr, // 必填，生成签名的随机串
  //   signature: data.signature, // 必填，签名
  //   jsApiList: ["chooseImage"], // 必填，需要使用的JS接口列表
  //   openTagList: ["wx-open-launch-app"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  // });
  // wx.ready(() => {
  //   console.log("wx ready");
  // });
  // wx.error((err) => {
  //   console.log("wx err", err);
  // });
});
</script>

<template>
  <RouterView />
</template>

<style scoped></style>
